<div class="form-wrapper">
  <mat-card appearance="outlined">
    <!-- prettier-ignore -->
    <div class="hydrao-card-title" i18n="@@register.page.title">Create new account</div>
    <form
      [formGroup]="registerForm"
      autocomplete="off"
      novalidate
      (ngSubmit)="register(registerForm.value)"
      fxLayout="column wrap"
      fxLayoutAlign="center center"
      fxLayoutGap="10px"
    >
      <mat-form-field>
        <!-- prettier-ignore -->
        <input
          required
          matInput
          i18n-placeholder="@@register.page.email"
          placeholder="Email"
          type="email"
          formControlName="email"
          id="email"
          autofocus
        />
        <!-- prettier-ignore -->
        <mat-error *ngIf="hasError('email', 'required')" i18n="@@register.page.emailRequired">Email is required</mat-error>
        <!-- prettier-ignore -->
        <mat-error *ngIf="hasError('email', 'email')" i18n="@@register.page.enterValidEmail">Please enter a valid email</mat-error>
      </mat-form-field>
      <mat-form-field>
        <!-- prettier-ignore -->
        <input
          required
          matInput
          i18n-placeholder="@@register.page.password"
          placeholder="Password"
          type="password"
          formControlName="pass"
          id="pass"
        />
        <!-- prettier-ignore -->
        <mat-error *ngIf="hasError('pass', 'required')" i18n="@@register.page.passwordRequired">Password is required</mat-error>
        <!-- prettier-ignore -->
        <mat-error *ngIf="hasError('pass', 'minlength')" i18n="@@register.page.toShortPassword">Password length is at least 8 characters</mat-error>
      </mat-form-field>
      <mat-form-field>
        <!-- prettier-ignore -->
        <input
          required
          matInput
          i18n-placeholder
          placeholder="password confirmation"
          type="password"
          formControlName="passConf"
          id="passConf"
        />
        <!-- prettier-ignore -->
        <mat-error *ngIf="hasError('passConf', 'required')" i18n="@@register.page.passwordConfirmationRequired">Password confirmation is required</mat-error>
        <!-- prettier-ignore -->
        <mat-error *ngIf="hasError('passConf', 'mustMatch')" i18n="@@register.page.passwordConfirmationMissMatch">Password confirmation does not match </mat-error>
      </mat-form-field>

      <div class="buttons">
        <!-- prettier-ignore -->
        <button
          mat-button
          type="button"
          color="primary"
          i18n="@@global.actions.back"
          (click)="goBack()"
        >Go Back</button>
        <!-- prettier-ignore -->
        <button
          mat-flat-button
          color="primary"
          [disabled]="!registerForm.valid"
          i18n="@@register.page.register"
        >register</button>
      </div>
      <mat-error class="error" *ngIf="errorCode" [ngSwitch]="errorCode">
        <!-- prettier-ignore -->
        <div *ngSwitchCase="'UserAlreadyExists'" i18n="@@global.actions.UserAlreadyExists">User already exists</div>
        <!-- prettier-ignore -->
        <div *ngSwitchDefault i18n="@@global.error.unexpectedError">Unexpected error, please try again</div>
      </mat-error>
    </form>
  </mat-card>
</div>
